/** @format */

import React from "react";
import { v4 as uuidv4 } from "uuid";

//material ui
import { Box, Divider, Stack, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import { Container } from "@mui/system";
import socialPlatforms from "../../helpers/socialPlatforms";
import mailicon from "../../img/Footer/iconMail.png";

//components
import Logo from "../../img/Footer/LogoP5Footer.svg";
import { Link } from "react-router-dom";

const useStyles = (theme, isMobile) => ({
	footer: {
		display: "flex",
		flexDirection: "column",
		borderRadius: "2.5rem 2.5rem 0 0",
		paddingTop: "4rem",
		alignItems: "center",
		justifyContent: "space-evenly",
		background:
			"linear-gradient(180deg, rgba(0,31,85,1) 0%, rgba(0,16,43,1) 100%)",
	},
	container: {
		display: "flex",

		flexDirection: isMobile ? "column" : "row",
		alignItems: "center",
		justifyContent: isMobile ? "center" : "space-between",
		margin: !isMobile ? "2rem 0 2rem 0" : "",

	},
	containerLogos: {
		box: {
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			margin:"auto"
		},
		logos: {
			display: "flex",
			justifyContent: isMobile ? "space-around" : "space-between",
			margin: "1.5rem 0 2rem 0",
			
		},
	},
	containerContacts: {
		box: {
			display: "flex",
			flexDirection: "column",
			alignItems: isMobile ? "center" : "",	
			margin:"auto"
		},
		links: {
			display: "flex",
			alignItems: "center",
			textDecoration: "none",
			color: "white",
			margin: ".5rem 0 1rem 0",
		},
		typography: {
			FontFamily: theme.typography.montserrat.regular,
			textDecoration: "underline",
			fontSize: "1 rem",
			marginLeft: isMobile ? "0" : ".4rem",
		},
	},
	containerSections: {
		box: {
			display: "flex",
			justifyContent: "space-between",
			flexDirection: isMobile ? "column" : "",
			alignItems: isMobile ? "center" : "",
			background:"red"

		},
		typography: {
			FontFamily: theme.typography.montserrat.regular,
			textDecoration: "underline",
			textAlign: isMobile ? "center" : "",
			color: "white",
			fontSize: "1 rem",
			margin:"auto"
		},
		links: {
			color: "#ffffff",
			cursor: "pointer"
		},
	},
	dividerDesktop: {
		borderWidth: ".05rem",
		height: isMobile ? "0" : "10rem",
		width: isMobile ? "20rem" : "0",
		margin: isMobile ? "2rem .5rem" : "",
		background: "#ffffff",
	},
	copy: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		textAlign: "center",
		background: !isMobile ? "#010e25" : "",
		lineHeight: "1.5rem",
		color: "whitesmoke",
		height: "5rem",
		width: "100%",
    fontFamily: "Montserrat, sans-serif",
    marginBottom: isMobile && "2rem"
	},
});

const Footer = () => {
	const isMobile = useMediaQuery("(max-width:1000px)");
	const tab = "\u00A0";
	const theme = useTheme();
	const classes = useStyles(theme, isMobile);


	const onScroll = () => {
		window.scrollTo(0, 0);
	};

	const handlePath = ()=>{
		const origin = window.location.origin
		window.location.href = `${origin}#programmingPath`
	}

	const handleFaqs = ()=>{
		const origin = window.location.origin
		window.location.href = `${origin}/faqs`
	}

	return (
		<footer style={classes.footer}>
			<Container maxWidth="xl">
				<Box sx={classes.container}>
					{/* //Logo */}
					<Box sx={classes.containerLogos.box}>
						<Box>
							<img src={Logo} alt="Plataforma 5 Logo" height="55px" />
						</Box>
						{isMobile ? null : (
							<Box sx={classes.containerLogos.logos}>
								{socialPlatforms.map((social) => (
									<a
										key={uuidv4()}
										href={social.link}
										rel={social.rel}
										target={social.target}>
										<img
											src={social.img}
											alt={social.alt}
											title={social.title}
											height="24rem"
										/>
									</a>
								))}
							</Box>
						)}
					</Box>

					<Divider
						orientation={isMobile ? "horizontal" : "vertical"}
						variant="middle"
						sx={classes.dividerDesktop}
					/>

					{/* //Contacto */}
					<Box sx={classes.containerContacts.box}>
						<a
							style={classes.containerContacts.links}
							href="mailto:contacto@plataforma5.la"
							rel="noopener noreferrer"
							target="_blank">
							{!isMobile ? (
								<img
									src={mailicon}
									alt="Mail Icon"
									title="Mail"
									height="24rem"
								/>
							) : null}
							<Typography sx={classes.containerContacts.typography}>
								contacto@plataforma5.la
							</Typography>
						</a>

						{isMobile ? (
							<Box sx={classes.containerLogos.logos}>
								{socialPlatforms.map((social) => (
									<a
										style={{ margin: "0.1rem .5rem" }}
										key={uuidv4()}
										href={social.link}
										rel={social.rel}
										target={social.target}>
										<img
											src={social.img}
											alt={social.alt}
											title={social.title}
											height="24rem"
										/>
									</a>
								))}
							</Box>
						) : null}
					</Box>

					<Divider variant="middle" sx={classes.dividerDesktop} />

					{/* //Secciones Pag */}
					{/* Cenetrar contenido */}
					<Box sx={classes.containerContacts.box}>
						<Stack spacing={2} sx={classes.containerSections.typography}>
						<Typography
								component={Link}
								to="/aplica"
								onClick={onScroll}
								style={classes.containerSections.links}>
								Aplicar{tab}
								<span role="img" aria-label="Rocket">
									🚀
								</span>
							</Typography>
							<Typography
								onClick={handlePath}
								style={classes.containerSections.links}>
								Tu Camino Dev
							</Typography>
							{/* Redireccionar a tu camino en la programación */}
							<Typography
								onClick={handleFaqs}
								style={classes.containerSections.links}>
								Preguntas Frecuentes
							</Typography>
						</Stack>
					</Box>

					{isMobile && <Divider variant="middle" sx={classes.dividerDesktop} />}
				</Box>
			</Container>

			{/* //Copy */}
			<Box style={classes.copy}>
				{!isMobile ? (
					"Copyright © Plataforma 5 SAS | Políticas de Privacidad"
				) : (
					<>
						<>Copyright © Plataforma 5 SAS</>
						<br />
						<>Políticas de Privacidad</>
					</>
				)}
			</Box>
		</footer>
	);
};

export default Footer;
